import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { Body2 } from 'ui/theme';

export const ColumnHeading = styled(Body2)`
  margin: 0;
  text-align: right;
`;

export const ShowMoreButton = styled(GhostButton)`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const ShowMoreFooter = styled.div`
  position: relative;
  margin-bottom: -${(props) => props.theme.spacing.utils.pxToRem(24)};
  min-height: ${(props) => props.theme.spacing.utils.pxToRem(34)};
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
